/**
 * Date/time text helpers for Vandaag (spec §8.1).
 * Pure functions — no fake personalization, Dutch copy only.
 */

/** Time-aware Dutch greeting: morning 05:00–11:59, afternoon 12:00–17:59, evening otherwise. */
export function greetingForHour(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Goedemorgen'
  if (hour >= 12 && hour < 18) return 'Goedemiddag'
  return 'Goedenavond'
}

/** Full Dutch date, e.g. 'woensdag 29 juli 2026'. */
export function formatDutchDate(date: Date): string {
  return new Intl.DateTimeFormat('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date)
}

/** Local wall-clock ISO date (yyyy-mm-dd) for repository calls. */
export function toLocalISODate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Minutes-from-midnight -> 'HH:mm'. */
export function formatMinutesOfDay(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
}

/** Minutes from start of day for a Date, matching PlannerItem.startMinute. */
export function minutesOfDay(date: Date): number {
  return date.getHours() * 60 + date.getMinutes()
}

/** Short Dutch timestamp for notifications/notes, e.g. '29 jul, 14:05'. */
export function formatShortDutchDateTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

/** First name of a display name, or null when absent. */
export function firstNameOf(displayName: string | null | undefined): string | null {
  if (!displayName) return null
  const first = displayName.trim().split(/\s+/)[0]
  return first && first.length > 0 ? first : null
}
